
(function () {
  const CREDIT_URL = "https://lirogo.com/shopify/";

  function exists() {
    return !!document.querySelector('a[href="' + CREDIT_URL + '"]');
  }

  function buildSmall() {
    const small = document.createElement('small');
    small.className = 'copyright__content';
    small.innerHTML = '<br> Desarrollado por <a href="' + CREDIT_URL + '" target="_blank">Lirogo Digital</a>';
    return small;
  }

  function insert() {
    if (exists()) return;

    // Caso 1: el wrapper original del copyright existe (show_copyright o payment_enable activos)
    const wrapper = document.querySelector('.footer_copyright_wrapper');

    if (wrapper) {
      let column = wrapper.querySelector('.footer__column.footer_bottom_copyright:not(.footer__payment)');

      if (column) {
        // Existe la columna de copyright, solo falta el link -> lo agregamos
        column.appendChild(buildSmall());
      } else {
        // Existe el wrapper pero no la columna de copyright (show_copyright estaba en false)
        // -> creamos la columna nosotros mismos
        const newColumn = document.createElement('div');
        newColumn.className = 'footer__column footer_bottom_copyright';
        newColumn.appendChild(buildSmall());
        const innerWrap = wrapper.querySelector('.caption.page-width') || wrapper;
        innerWrap.insertBefore(newColumn, innerWrap.firstChild);
      }
      return;
    }

    // Caso 2: ni el wrapper existe (show_copyright Y payment_enable ambos en false,
    // o directamente se borró/desactivó todo el bloque) -> lo creamos desde cero al final del footer
    const footer = document.querySelector('footer, .footer');
    if (!footer) return;

    const fallbackWrapper = document.createElement('div');
    fallbackWrapper.className = 'footer_copyright_wrapper footer__content-bottom-wrapper--center';
    fallbackWrapper.innerHTML =
      '<div class="caption page-width footer__content-bottom-wrapper">' +
        '<div class="footer__column footer_bottom_copyright">' +
          '<small class="copyright__content">Desarrollado por <a href="' + CREDIT_URL + '" target="_blank">Lirogo Digital</a></small>' +
        '</div>' +
      '</div>';
    footer.appendChild(fallbackWrapper);
  }

  document.addEventListener('DOMContentLoaded', insert);
  window.addEventListener('load', function () {
    insert();
    new MutationObserver(function () {
      if (!exists()) insert();
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
